import React, { JSX, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { LaunchErrorCodes, LaunchType } from '../../../enums';
import { CCEuro24GameId } from '../../../constants';
import { DefaultErrorPage } from './default';
import { useStore } from '../../../hooks';

interface ErrorPageProps {
  /** Overrides the launch-data code, for callers that render this page with no launch data at all. */
  errorCode?: LaunchErrorCodes;
}

export const ErrorPage: React.FC<ErrorPageProps> = observer(({ errorCode }) => {

  const { gameStore } = useStore();
  const { isTronix, launchData: { data: launchData } } = gameStore;

  const showPascalLogo = launchData?.gameId !== CCEuro24GameId;

  const defaultErrorPage = useMemo(() => (
    <DefaultErrorPage
      isTronix={isTronix}
      exitUrl={launchData?.exitUrl}
      showPascalLogo={showPascalLogo}
      // `??`, not `||`: GENERAL_ERROR is 0, which `||` would discard.
      errorCode={errorCode ?? launchData?.errorCode}
      gameLogoUrl={launchData?.gameLogoUrl}
    />
  ), [isTronix, showPascalLogo, launchData, errorCode]);

  const integrationErrorPages = useMemo<Partial<Record<LaunchType, JSX.Element>>>(() => ({
    [LaunchType.Pascal]: defaultErrorPage,
    [LaunchType.BetConstruct]: defaultErrorPage,
  }), [defaultErrorPage]);

  if (!launchData) {
    return defaultErrorPage;
  }

  return (
    integrationErrorPages[launchData.launchType] || defaultErrorPage
  );
});
